import { postRequest } from "api";
import {
  IEmergencyContactLoginInput,
  ILoginInput,
  ILoginResponse,
} from "models/auth";

export const loginApi = (data: ILoginInput) => {
  return postRequest<ILoginResponse>("auth/admin/login", data);
};

export const emergencyContactLoginApi = (
  data: IEmergencyContactLoginInput,
  type: string
) => {
  // Prepend +251 to phone number if not already present
  const phoneWithCountryCode = data.phone.startsWith('+251') 
    ? data.phone 
    : `+251${data.phone}`;
  
  (data as any).type = type;
  return postRequest<ILoginResponse>("emergency-contacts/login", {
    ...data,
    phone: phoneWithCountryCode
  });
};
